import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import SideNavBar from '../../../../_components/common/SideNavBar'
import { superAdminAreaData } from '../../OrgAdminArea/SidebarData'
import UtilityNav from '../../../../_components/common/UtilityNav'
import ModalComponent from '../../../../_components/common/Modal';
import { Table } from 'reactstrap';
import TableNew from '../../../../_components/common/Table';
import { addCredits, revokeCredits } from './formdata';
import { superAdminAction } from '../../../../_actions';

class ManageCredits extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            addCreditsModal: false,
            revokeCreditsModal: false,
            orgId: null,
            updateModalState: false,
            updateMessage: null,
            navData: [],
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {

        this.setState({
            orgId: +this.props.match.params.id
        })
        this.props.dispatch(superAdminAction.getCreditsHandler(+this.props.match.params.id, () => { }))

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
    }

    toggleEntireCreditsModal(showModal) {
        this.setState({
            addCreditsModal: showModal,
            revokeCreditsModal: showModal,
        })
    }

    toggleaddCreditsModal(showModal) {
        this.setState({
            addCreditsModal: showModal
        })
        addCredits.map(
            (data, i) => {
                this.resetData(data)
            }
        )
    }

    resetData(data) {
        data.value = '';
        if (data.validation.required === true) {
            data.valid = false;
        }
    }

    togglerevokeCreditsModal(showModal) {
        this.setState({
            revokeCreditsModal: showModal
        })
        revokeCredits.map(
            (data, i) => {
                this.resetData(data)
            }
        )
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    actionSelected(data) {
        const fd = {
            "organisation_id": this.state.orgId,
            "add_credits": data.data.add_credits
        }
        this.props.dispatch(superAdminAction.addCreditsHandler(fd, (response) => {
            this.setState({
                deleteOrgModal: false,
                updateMessage: {
                    status: response.status,
                    text: `<div className = " text-center">
                    <p className = "font-weight-bold">${response.status === 200 ? 'Success!' : 'Error!'}</p>
                    <p>${data.data.add_credits} credit(s) added successfully.</p>
                </div>`,
                    heading: 'Credits to be added',
                    headerColor: response.status === 200 ? `` : `bg-danger`,
                    headingIcon: response.status === 200 ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                },
                updateModalState: true
            })
        }))
    }

    actionSelectedRevoke(data) {
        const fd = {
            "organisation_id": this.state.orgId,
            "remove_credits": data.data.revoke_credits
        }

        this.props.dispatch(superAdminAction.revokeCreditsHandler(fd, (response) => {
            this.setState({
                deleteOrgModal: false,
                updateMessage: {
                    status: response.status,
                    text: `<div className = " text-center">
                    <p className = "font-weight-bold">${response.status === 200 ? 'Success!' : 'Error!'}</p>
                    <p>${response.data.message}</p>
                </div>`,
                    heading: 'Credits to be removed',
                    headerColor: response.status === 200 ? `` : `bg-danger`,
                    headingIcon: response.status === 200 ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                },
                updateModalState: true
            })
        }))
    }

    getReformatData = (response) => {
        const data = [{
            'total_credits': response.total_credits,
            'alloted_credits': response.alloted_credits,
            'credits_unalloted': response.total_credits - response.alloted_credits,
        }]
        return data
    }

    render() {
        const { getCreditsResponse } = this.props;

        const tables = {
            Team: [{
                name: 'Total Credits',
                key: 'total_credits',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: true,
                headingAlign: true,
                link: ''
            },
            {
                name: 'Allotted',
                key: 'alloted_credits',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: true,
                headingAlign: true,
                link: ''
            }, {
                name: 'Unallotted',
                key: 'credits_unalloted',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: true,
                headingAlign: true,
                link: ''
            },
            ]
        }

        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={superAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">MANAGE CREDITS</h5>
                        <UtilityNav
                            actionButtons={[
                                {
                                    id: 1,
                                    name: 'Add Credits',
                                    toggler: this.toggleaddCreditsModal.bind(this),
                                    togglerModal: this.state.addCreditsModal,
                                    icon: 'fa fa-plus',
                                    title: 'Add Credits'
                                }, {
                                    id: 2,
                                    name: 'Revoke Credits',
                                    toggler: this.togglerevokeCreditsModal.bind(this),
                                    togglerModal: this.state.revokeCreditsModal,
                                    icon: 'fa fa-minus',
                                    title: 'Revoke Credits'
                                }
                            ]}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        {
                            getCreditsResponse !== '' &&
                            <TableNew
                                data={this.getReformatData(getCreditsResponse)}
                                columns={tables.Team}


                            />
                        }

                        {
                            (getCreditsResponse === '') &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                &nbsp;Loading</p>
                        }

                        {
                            this.state.addCreditsModal &&
                            <ModalComponent
                                showModal={this.state.addCreditsModal}
                                heading="Credits to be added"
                                formData={addCredits}
                                action={this.actionSelected.bind(this)}
                                toggleEntireModal={this.toggleEntireCreditsModal.bind(this)}
                                footerFormSubmitButton={['Add', 'Cancel']}
                            />
                        }

                        {
                            this.state.revokeCreditsModal &&
                            <ModalComponent
                                showModal={this.state.revokeCreditsModal}
                                heading="Credits to be removed"
                                formData={revokeCredits}
                                action={this.actionSelectedRevoke.bind(this)}
                                toggleEntireModal={this.toggleEntireCreditsModal.bind(this)}
                                footerFormSubmitButton={['Remove', 'Cancel']}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {
    const { getCreditsLoading } = state.getCreditsReducer;
    const getCreditsError = state.getCreditsReducer.error;
    const getCreditsResponse = (!getCreditsLoading && !getCreditsError) ? state.getCreditsReducer.data.data.organisation_credit_record : '';

    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';
    return {
        getCreditsResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(ManageCredits);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/ManageCredits/index.js